import React from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, Box, Paper, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { articles } from "../data/articles";

const Article: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  if (!article) {
    return (
      <Container maxWidth="md" sx={{ mt: 8, textAlign: "center" }}>
        <Typography variant="h5" color="error">
          Artigo não encontrado.
        </Typography>
        <Button component={Link} to="/articles" sx={{ mt: 2 }} startIcon={<ArrowBack />}>
          Voltar para a lista de artigos
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography component="h1" variant="h4" gutterBottom>
          {article.title}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          Publicado em: {article.date}
        </Typography>
        <Box sx={{ my: 4 }}>
          {article.image && <img src={article.image} alt={article.title} style={{ width: "100%", borderRadius: "8px" }} />}
        </Box>
        <Typography
          component="div"
          variant="body1"
          sx={{ "& h2": { mt: 3, mb: 1 }, "& p": { mb: 2 } }}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
        <Box sx={{ mt: 4 }}>
          <Button component={Link} to="/articles" startIcon={<ArrowBack />}>
            Voltar para a lista de artigos
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Article;
